import { useEffect, useState } from "react"
import { AttyTabColor, LiabilityTabColor, MajorMedColor, MedPayTabColor, UMTabColor } from "../../../lib/detailsTabsColors"

import classes from './VerificationBoxCustom.module.css'

export default function VerificationBoxCustom({rowData, type}) {
    const [tabStatus, setTabStatus] = useState({
        dot: false,
        dot_color: null,
        background: null,
        color: `var(--white)`,
        message: null,
        classColor: null
    })

    useEffect(() => {
        if(rowData) {
            if (type == 'atty') {
                const attyActiveCase = {
                    case: rowData.case,
                    practices: rowData.practices ?? [],
                    procodocs_documents: rowData.procodocs_documents ?? [],
                    attorneys: rowData.attorney ? [rowData.attorney] : [],
                    case_attorney: rowData.attorney ?? rowData.case_attorney,
                }
                let status = AttyTabColor(rowData.attorney, rowData.liabilities, rowData.case_additional, attyActiveCase)
                setTabStatus(status)
            }
            if (type == 'liability') {
                let status = LiabilityTabColor(rowData.liability)
                setTabStatus(status)
            }
            if (type == 'medpay') {
                let status = MedPayTabColor(rowData.mp_pip_um)
                setTabStatus(status)
            }       

            if (type == 'um') {            
                let status = UMTabColor(rowData.mp_pip_um, rowData.liabilities)
                setTabStatus(status)
            }

            if (type == 'majormed') {            
                let status = MajorMedColor(rowData.major_med, rowData)
                setTabStatus(status)
            }
        }
        

        
    }, [rowData, type])

    return <div className={`${classes.box} ${tabStatus.classColor ? tabStatus.classColor : ''}`} style={{background: tabStatus.background, color: tabStatus.color}} ></div>
}